import React, { useEffect, useState } from "react";
import "./PnLFloorplanDetails.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
    PnLElevationInfoContainer,
    PnLElevationSelectButton,
    PnLFloorplanProductImageDisplay,
} from "./PnLFloorplanDetailsParts";
import { BackArrow, NextArrow, PrevArrow } from "./PnLFloorplanIconsSvg";
import {
    updateActiveElevation,
    updateActiveFloor,
    updateActiveFloorplan,
} from "../../redux/actions/floorplanActions";
import Cover from "../Cover/Cover";
import FloorplanDetailsSendEmailModal from "../FloorplanDetailsSendEmailModal/FloorplanDetailsSendEmailModal";

function PnLFloorplanDetails(props) {
    var content = useSelector((state) => state.content);
    //var floorplans = useSelector(state => state.floorplan.activeFloorplans);
    var floorplans = useSelector((state) => state.floorplan.floorplans);
    var activeFloorplanID = useSelector(
        (state) => state.floorplan.activeFloorplanID
    );
    var activeElevationID = useSelector(
        (state) => state.floorplan.activeElevationID
    );
    var history = useHistory();
    //var [currentFloor, setCurrentFloor] = useState(0);
    var currentFloor = useSelector((state) => state.floorplan.activeFloorID);
    var [modalOpen, setModalOpen] = useState(false);
    var isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var [emailModalOpen, setEmailModalOpen] = useState(false);
    var dispatch = useDispatch();

    //code to fix the url

    function contentNotReady() {
        return <div className="loading" />;
    }

    function getPreviousFloorInfo() {
        //get the label for the previous floor if it exists ?
        var lbl = " ";

        if (currentFloor - 1 >= 0) {
            lbl =
                floorplans[activeFloorplanID].elevation[activeElevationID]
                    .floorplan_designs[currentFloor].category;
        }

        return lbl;
    }

    function getNextFloorInfo() {
        //get the label for the previous floor if it exists ?
        var lbl = " ";

        if (currentFloor - 1 >= 0) {
            lbl =
                floorplans[activeFloorplanID].elevation[activeElevationID]
                    .floorplan_designs[currentFloor].category;
        }

        return lbl;
    }

    function interactiveColourClass(floorplan) {
        var rtn = "";

        if (floorplan.type[0].name == "36'") {
            rtn = " green";
        } else if (floorplan.type[0].name == "40'") {
            rtn = " orange";
        }

        return rtn;
    }

    function toggleModal() {
        var open = !modalOpen;

        setModalOpen(open);
    }

    function closeModal() {
        setModalOpen(false);
    }

    function openModal() {
        setModalOpen(true);
    }

    function updateCurrentFloor(index) {
        //this needs to be redux now
        dispatch(updateActiveFloor(index));
    }

    //okay check the url for a floorplan type. if we don't have one check if
    //we have something active because this is when we're not loading into the page

    if (
        activeFloorplanID == -1 ||
        (activeElevationID == -1 && "floorplans" in content.pages)
    ) {
        //grab the last part
        var location = history.location.search;
        var part = location.split("=");
        part = part[part.length - 1];

        //check all of the floorplans to see if the title matches any of them
        if (floorplans.length > 0 && part != "") {
            //time to check for the redirect
            var clnTitle = decodeURI(part.toLowerCase());

            for (var i = 0; i < floorplans.length; i++) {
                if (clnTitle == floorplans[i].post_title.toLowerCase()) {
                    //we found a match set the active floorplan to this one and the elevation to 0
                    //now we can set the values if we dont have them and change the title
                    dispatch(updateActiveFloorplan(i));
                    dispatch(updateActiveElevation(0));
                    break;
                }
            }
        }
        if (floorplans.length > 0 && part == "")
            history.push("/floorplans/select-products");
    }

    if (
        typeof floorplans !== "undefined" &&
        floorplans.length > 0 &&
        activeFloorplanID != -1 &&
        activeElevationID != -1 &&
        "floorplans" in content.pages
    ) {
        var floorplan = floorplans[activeFloorplanID];
        var elevation = floorplan.elevation[activeElevationID];
        var plans = elevation.floorplan_designs;
        var decoration =
            content.pages.floorplans.floorplan_product_modal_decorations;
        var modalClasses = "PnLFloorplanDetails-fullscreen-modal-container";

        if (modalOpen) modalClasses += " active";

        //force the url to be right
        history.replace(
            `/floorplans/details/${floorplan.post_title.toLowerCase()}`
        );

        return (
            <div
                className={`PnLFloorplanDetails${interactiveColourClass(floorplan)}${isTouchScreen ? " touchscreen" : ""}`}
            >
                <Cover fadeImmediately />
                <FloorplanDetailsSendEmailModal
                    open={modalOpen}
                    close={closeModal}
                    label={
                        floorplan.post_title + " " + elevation.elevation_name
                    }
                    floorplans={[
                        {
                            ID: floorplan.ID,
                            elevation: activeElevationID,
                        },
                    ]}
                />
                <div className="info-container">
                    <div className="image-container">
                        <img
                            className="image"
                            src={elevation.elevation_image}
                        />
                    </div>
                    <div className="elevation-selection-bar">
                        {floorplan.elevation.map((elev, ekey) => (
                            <PnLElevationSelectButton
                                letter={elev.elevation_name}
                                index={ekey}
                                active={ekey == activeElevationID}
                            />
                        ))}
                    </div>
                    <div className="elevation-container">
                        {plans.map((plan, key) => (
                            <PnLElevationInfoContainer
                                floorplan={floorplan}
                                plans={plan}
                                elevation={elevation}
                                active={activeElevationID == key}
                                emailButtonCB={toggleModal}
                            />
                        ))}
                    </div>
                </div>
                <div className="preview-container">
                    <div className="display-container">
                        {plans.map((plan, pkey) => (
                            <PnLFloorplanProductImageDisplay
                                plan={plan}
                                index={pkey}
                                active={currentFloor == pkey}
                                key={pkey}
                            />
                        ))}
                    </div>
                    <div
                        className={`switcher-container${plans.length > 3 ? " four" : ""}`}
                    >
                        {plans.map((plan, pkey) => {
                            var switchClasses = "switch-button";
                            if (pkey == currentFloor)
                                switchClasses += " active";

                            return (
                                <button
                                    className={switchClasses}
                                    key={pkey}
                                    onClick={() => updateCurrentFloor(pkey)}
                                >
                                    {plan.category}
                                </button>
                            );
                        })}
                    </div>
                </div>
                <div className="disclaimer-container">
                    <p className="disclaimer">
                        {content.pages.floorplans.floorplan_product_disclaimer}
                    </p>
                    {!isTouchScreen && (
                        <button
                            className="back-button"
                            onClick={() => {
                                dispatch(updateActiveFloor(0));
                                dispatch(updateActiveElevation(-1));
                                dispatch(updateActiveFloorplan(-1));
                                history.push("/floorplans/list");
                            }}
                        >
                            <BackArrow />{" "}
                            <span className="label">Back to floorplans</span>
                        </button>
                    )}
                </div>
                <div className={modalClasses}>
                    <div className="image-display-wrapper">
                        {plans[currentFloor].plans.map((plan, pkey) => (
                            <div className="plan-wrapper">
                                <span className="label">{plan.label}</span>
                                <img
                                    className="plan-image"
                                    src={plan.plan_image}
                                />
                            </div>
                        ))}
                    </div>
                    <button className="previous-button">
                        <PrevArrow />
                        <span className="label">{getPreviousFloorInfo()}</span>
                    </button>
                    <button className="next-button">
                        <span className="label">{getNextFloorInfo()}</span>
                        <NextArrow />
                    </button>
                    <img
                        className="left-decoration"
                        src={decoration.left_decoration}
                    />
                    <img
                        className="right-decoration"
                        src={decoration.right_decoration}
                    />
                </div>
            </div>
        );
    } else {
        return contentNotReady();
    }
}

export default PnLFloorplanDetails;

